module.exports = __webpack_public_path__ + "8642745b882e8373ad4b80021f612fba.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-footer/sp-footer.html
// module id = 1002
// module chunks = 0